/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_Email_NoteInputs */

const tr_cerez_s5_email_note = /** @type {(inputs: Cerez_S5_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderdiğimiz e-postalardaki açılma ve tıklama ölçümü Gizlilik Politikası'nda açıklanmıştır.`)
};

const en_cerez_s5_email_note = /** @type {(inputs: Cerez_S5_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open and click measurement in the emails we send is described in the Privacy Policy.`)
};

const de_cerez_s5_email_note = /** @type {(inputs: Cerez_S5_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Öffnungs- und Klickmessung in unseren E-Mails ist in der Datenschutzerklärung beschrieben.`)
};

const ru_cerez_s5_email_note = /** @type {(inputs: Cerez_S5_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учёт открытий и кликов в наших письмах описан в Политике конфиденциальности.`)
};

/**
* | output |
* | --- |
* | "Open and click measurement in the emails we send is described in the Privacy Policy." |
*
* @param {Cerez_S5_Email_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_email_note = /** @type {((inputs?: Cerez_S5_Email_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_Email_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_email_note(inputs)
	if (locale === "de") return de_cerez_s5_email_note(inputs)
	if (locale === "ru") return ru_cerez_s5_email_note(inputs)
	return tr_cerez_s5_email_note(inputs)
});